/*
 * Build your bag: the only file that touches theme internals (Prestige 9.3.0).
 * Porting to another theme means rewriting this file and nothing else.
 *
 * Exposes window.bybAdapter:
 * - addItemsToCart(items): one POST to /cart/add.js, bundling the sections the theme re-renders (the cart drawer
 *   answers the theme's cart:prepare-bundled-sections event with its section id, as it does for the product form).
 *   Resolves { ok, status, json } and never throws on an HTTP error; a network error rejects.
 * - refreshCart(result): hands the new cart and the bundled section HTML to the theme through its cart:change event,
 *   which re-renders the drawer and the cart count. Without sections it falls back to the theme's cart:refresh.
 * - openCartDrawer(): opens <cart-drawer>, or goes to the cart page when the theme is set to a cart page (or has no
 *   drawer on this page).
 */
(() => {
  const root = () => window.Shopify?.routes?.root || '/';
  const cartType = () => window.themeVariables?.settings?.cartType || 'drawer';

  const bundledSections = () => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
    return sections;
  };

  const addItemsToCart = async (items) => {
    const response = await fetch(`${root()}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items, sections: bundledSections().join(',') })
    });

    let json = {};
    try {
      json = await response.json();
    } catch (error) {
      // An empty or non-JSON body is reported through ok and status
    }

    return { ok: response.ok, status: response.status, json };
  };

  const refreshCart = async (result) => {
    const sections = result?.json?.sections;

    if (!sections || cartType() === 'page') {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    }

    const cart = await (await fetch(`${root()}cart.js`)).json();
    cart.sections = sections;

    // baseEvent is not "variant:add", so the drawer re-renders here and opens only through openCartDrawer
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'byb:add', cart } }));
  };

  const openCartDrawer = () => {
    const drawer = document.querySelector('cart-drawer');

    if (cartType() === 'page' || !drawer || typeof drawer.show !== 'function') {
      window.location.href = `${root()}cart`;
      return;
    }

    drawer.show();
  };

  window.bybAdapter = { addItemsToCart, refreshCart, openCartDrawer };
})();
